






































import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
// import {AuditUserLogType} from "@/api/appService";

@Component({ name: "AuditTabOfExternalProject", components: { AuditTabPane } })
export default class AuditTabOfExternalProject extends Vue {
  get fetchData() {
    return api.externalProject.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "externalProjectProposal-detail",
      params: {
        id: dto.id,
      },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
